import { Resolver, ValidationMode } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginSchema } from "@/utils/validation/loginSchema";

export const formConfig = {
  resolver: yupResolver(loginSchema) as Resolver<ILoginForm>,
  mode: "all" as keyof ValidationMode,
  defaultValues: { username: "", password: "", remember: false },
};
